import * as angular from "angular";

angular
  .module('bringoz.admin.commissions', [
    'bringoz.admin.commons',
    'bringoz.admin.payments'
  ]);
